import { useContext } from 'react';
import { Button, Grid, Typography, FormControlLabel, Checkbox, MenuItem } from '@mui/material';
import { Form, Field, useFormikContext } from 'formik';
import { TextField } from 'formik-mui';
import * as yup from 'yup';
import { Link, useLocation } from 'react-router-dom';
import { userSchema } from '../UserDetailsContext';
import { applicationContext } from 'helpers/services';

let UserForm = () => {
    let router = useLocation();
    let appService = useContext(applicationContext);

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? 'New user' : `Edit user`;

    type User = yup.InferType<typeof userSchema>;
    let form = useFormikContext<User>();

    return (
        <Form>
            <Grid container alignItems='center'>
                <Grid item xs>
                    <Typography gutterBottom variant="h4">{title}</Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="medium"
                        component={Link}
                        to={'/admin/user'}
                    >
                        Cancel
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
            <Grid container alignItems='center'>
                <Grid item xs={6}>
                    <Field
                        component={TextField}
                        name="firstName"
                        label="First name"
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
                <Grid item xs={6}>
                    <Field
                        component={TextField}
                        name="lastName"
                        label="Last name"
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="email"
                        label="Email"
                        disabled={isNew === false}
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
                <Grid item>
                    <FormControlLabel
                        label="Is Admin"
                        name="isAdmin"
                        value={form.values.isAdmin}
                        checked={form.values.isAdmin}
                        onChange={(e: any) => form.setFieldValue('isAdmin', e.target.checked)}
                        control={<Field type="checkbox" name="isAdmin" component={Checkbox} />}
                    />
                </Grid>
                <Grid item>
                    <FormControlLabel
                        label="Can edit order address"
                        name="canEditOrderAddress"
                        value={form.values.canEditOrderAddress}
                        checked={form.values.canEditOrderAddress}
                        onChange={(e: any) => form.setFieldValue('canEditOrderAddress', e.target.checked)}
                        control={<Field type="checkbox" name="canEditOrderAddress" component={Checkbox} />}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="vendorCode"
                        label="Vendor Code"
                        fullWidth
                        margin="dense"
                        size='small'
                        select
                        SelectProps={{
                            multiple: true
                        }}
                    >
                        {appService.referenceData.ERPVendorCodes.map((erpVendorCode) =>
                            <MenuItem key={erpVendorCode.key} value={erpVendorCode.key}>{erpVendorCode.value}</MenuItem>
                        )}
                    </Field>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">Order Sync notifications</Typography>
                    <FormControlLabel
                        label="Receives Technical Error"
                        name="receiveOrderSyncErrors"
                        value={form.values.receiveOrderSyncErrors}
                        checked={form.values.receiveOrderSyncErrors}
                        onChange={(e: any) => form.setFieldValue('receiveOrderSyncErrors', e.target.checked)}
                        control={<Field type="checkbox" name="receiveOrderSyncErrors" component={Checkbox} />}
                    />
                    <FormControlLabel
                        label="Receives Data Error"
                        name="receiveOrderDataError"
                        value={form.values.receiveOrderDataError}
                        checked={form.values.receiveOrderDataError}
                        onChange={(e: any) => form.setFieldValue('receiveOrderDataError', e.target.checked)}
                        control={<Field type="checkbox" name="receiveOrderDataError" component={Checkbox} />}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="channelTypes"
                        label="Channel Types"
                        fullWidth
                        margin="dense"
                        size='small'
                        select
                        SelectProps={{
                            multiple: true
                        }}
                    >
                        {appService.referenceData.ChannelType.map((channelType) =>
                            <MenuItem key={channelType.key} value={channelType.key}>{channelType.value}</MenuItem>
                        )}
                    </Field>
                </Grid>
            </Grid>
        </Form>
    );
}

export default UserForm;